/** Словарь отображения шаблона лендинга (значение хранится в БД на английском). */
export const LEAD_TEMPLATE_LABELS: Record<string, string> = {
  selection: 'Подбор',
  insurance: 'Страхование',
  leasing: 'Лизинг',
};

/** Словарь отображения страницы-источника (path из attribution). */
export const LEAD_PATH_LABELS: Record<string, string> = {
  '/': 'Главная',
  contacts: 'Контакты',
  '/contacts': 'Контакты',
  selection: 'Подбор',
  '/selection': 'Подбор',
  insurance: 'Страхование',
  '/insurance': 'Страхование',
  leasing: 'Лизинг',
  '/leasing': 'Лизинг',
};

/** Явные значения form_source (ключ хранится в БД на английском). */
export const LEAD_FORM_SOURCE_LABELS: Record<string, string> = {
  hero_quick: 'Быстрая форма',
  detailed: 'Подробная форма',
  header_callback: 'Заказ звонка (шапка)',
  faq_callback: 'Заказ звонка (FAQ)',
  modal: 'Модальное окно',
  modal_hero: 'Форма (кнопка в hero)',
  modal_usp: 'Форма (блок преимуществ)',
  modal_categories: 'Форма (категории)',
  modal_value: 'Форма (ценность)',
  modal_process: 'Форма (процесс)',
  modal_comparison: 'Форма (сравнение)',
  modal_final: 'Форма (финальный блок)',
  home_header: 'Главная: заказ звонка (шапка)',
  home_hero: 'Главная: заказ звонка (hero)',
  home_contacts: 'Главная: заказ звонка (контакты)',
  home_selection_card: 'Главная: карточка «Подбор»',
  home_leasing_card: 'Главная: карточка «Лизинг»',
  home_insurance_card: 'Главная: карточка «Страхование»',
  contacts_header: 'Контакты: заказ звонка (шапка)',
  contacts_hero: 'Контакты: заказ звонка (hero)',
  test: 'Тест',
};

/** Префиксы form_source для лендингов (selection без префикса). */
const LEAD_FORM_SOURCE_PREFIX_LABELS: Record<string, string> = {
  insurance: 'Страхование',
  leasing: 'Лизинг',
};

export const getLeadTemplateLabel = (template?: string | null): string => {
  if (!template) return '-';
  return LEAD_TEMPLATE_LABELS[template] ?? template;
};

export const getLeadPathLabel = (path?: string | null): string => {
  if (!path) return '-';

  const normalized = path.trim();
  if (!normalized) return '-';

  return (
    LEAD_PATH_LABELS[normalized] ??
    LEAD_PATH_LABELS[normalized.replace(/^\//, '')] ??
    LEAD_PATH_LABELS[`/${normalized.replace(/^\//, '')}`] ??
    normalized
  );
};

export const getLeadFormSourceLabel = (formSource?: string | null): string => {
  if (!formSource) return '-';

  const normalized = formSource.trim();
  if (!normalized) return '-';

  const exact = LEAD_FORM_SOURCE_LABELS[normalized];
  if (exact) return exact;

  for (const [prefix, prefixLabel] of Object.entries(LEAD_FORM_SOURCE_PREFIX_LABELS)) {
    const marker = `${prefix}_`;
    if (!normalized.startsWith(marker)) continue;

    const suffix = normalized.slice(marker.length);
    const suffixLabel = LEAD_FORM_SOURCE_LABELS[suffix];
    if (suffixLabel) {
      return `${prefixLabel}: ${suffixLabel.charAt(0).toLowerCase()}${suffixLabel.slice(1)}`;
    }
  }

  return normalized;
};

export type LeadTranslatedExportField = 'type' | 'template' | 'path' | 'form_source';

const LEAD_EXPORT_LABEL_GETTERS: Record<
  LeadTranslatedExportField,
  (value?: string | null) => string
> = {
  type: getLeadTemplateLabel,
  template: getLeadTemplateLabel,
  path: getLeadPathLabel,
  form_source: getLeadFormSourceLabel,
};

/** Форматирует поле источника для Excel — те же переводы, что в карточке заявки. */
export const formatLeadExportValue = (
  field: LeadTranslatedExportField,
  value: unknown,
): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const label = LEAD_EXPORT_LABEL_GETTERS[field](String(value));
  return label === '-' ? '' : label;
};

export const isLeadTranslatedExportField = (
  field: string,
): field is LeadTranslatedExportField => field in LEAD_EXPORT_LABEL_GETTERS;
